import { UploadException } from './upload.exception';

export class InvalidFileTypeException extends UploadException {
  public constructor(message = 'Invalid file type exception.') {
    super(message);
  }
}
